import { Reducer, combineReducers } from '@reduxjs/toolkit';
import messagesList from '../features/MessagesList/MessagesListSlice';
import logsList from '../features/LogsList/LogsListSlice';
import lotsList from '../features/LotsList/LotsListSlice';
import organizationsList from '../features/OrganizationsList/OrganizationsListSlice';
import complexesList from '../features/ComplexesList/ComplexesListSlice';
import requestsList from '../features/RequestsList/RequestsListSlice';
import favouritesList from '../features/FavouritesList/FavouritesListSlice';
import consultationsList from '../features/ConsultationsList/ConsultationsListSlice';
import libraries from '../features/Libraries/LibrariesSlice';
import user from '../features/User/UserSlice';
import createLotModal from '../features/CreateLotModal/CreateLotModalSlice';
import createComplexModal from '../features/CreateComplexModal/CreateComplexModalSlice';
import createOrganizationModal from '../features/CreateOrganizationModal/CreateOrganizationModalSlice';
import editLotModal from '../features/EditLotModal/EditLotModalSlice';
import editComplexModal from '../features/EditComplexModal/EditComplexModalSlice';
import editOrganizationModal from '../features/EditOrganizationModal/EditOrganizationModalSlice';
import usersList from '../features/UsersList/UsersListSlice';
import { IUsersListState } from 'features/UsersList/interfaces';
import { IEditLotModalState } from 'features/EditLotModal/interfaces';
import { ICreateLotModalState } from 'features/CreateLotModal/interfaces';
import { IUserState } from 'features/User/interfaces';
import { ILibrariesState } from 'features/Libraries/interfaces';
import { IRequestsListState } from 'features/RequestsList/interfaces';
import { IFavouritesListState } from 'features/FavouritesList/interfaces';
import { IOrganizationsListState } from 'features/OrganizationsList/interfaces';
import { ILotsListState } from 'features/LotsList/interfaces';
import { ILogsListState } from 'features/LogsList/interfaces';
import { IMessagesListState } from 'features/MessagesList/interfaces';
import { IComplexesListState } from 'features/ComplexesList/interfaces';
import { ICreateOrganizationModalState } from 'features/CreateOrganizationModal/interfaces';
import { ICreateComplexModalState } from 'features/CreateComplexModal/interfaces';
import { IEditOrganizationModalState } from 'features/EditOrganizationModal/interfaces';
import { IEditComplexModalState } from 'features/EditComplexModal/interfaces';
import { IConsultationsListState } from 'features/ConsultationsList/interfaces';

const rootReducer: Reducer<{
	messagesList: IMessagesListState;
	logsList: ILogsListState;
	lotsList: ILotsListState;
	organizationsList: IOrganizationsListState;
	complexesList: IComplexesListState;
	requestsList: IRequestsListState;
	favouritesList: IFavouritesListState;
	consultationsList: IConsultationsListState;
	libraries: ILibrariesState;
	user: IUserState;
	usersList: IUsersListState;
	createLotModal: ICreateLotModalState;
	createComplexModal: ICreateComplexModalState;
	createOrganizationModal: ICreateOrganizationModalState;
	editLotModal: IEditLotModalState;
	editComplexModal: IEditComplexModalState;
	editOrganizationModal: IEditOrganizationModalState;
}> = combineReducers({
	messagesList,
	logsList,
	lotsList,
	organizationsList,
	complexesList,
	requestsList,
	favouritesList,
	consultationsList,
	libraries,
	user,
	createLotModal,
	createComplexModal,
	createOrganizationModal,
	editLotModal,
	editComplexModal,
	editOrganizationModal,
	usersList,
});

export default rootReducer;
